import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { activityLogsKeys } from './getActivityLogs';
import { fileDetailsKeys } from './getFileDetails';

import { isResponseError } from '../../../../api/config';
import { entryActionCustomValidateOptions } from '../../../../api/inbox';
import { UpdateFileEntryResponse } from '../../../../types';

const url = `${PREFIX_URL}/inbox-documents/:fileId`;

export type TagFileWorkstreamDTO = {
  fileId: number;
  workstreamIds: number[];
};

export const tagFileWorkstream = ({
  fileId,
  workstreamIds,
}: TagFileWorkstreamDTO): Promise<UpdateFileEntryResponse> => {
  return axios.put(
    generateRoutePath(url, { fileId }),
    { 'workstream-ids': workstreamIds },
    {
      ...entryActionCustomValidateOptions,
    }
  );
};

type useTagFileWorkstreamOptions = {
  fileId: number;
  config?: MutationConfig<typeof tagFileWorkstream>;
};

export const useTagFileWorkstream = ({ fileId, config }: useTagFileWorkstreamOptions) => {
  return useMutation({
    onSuccess: (data) => {
      if (isResponseError(data)) {
        return;
      }

      queryClient.setQueryData([...fileDetailsKeys.detail({ fileId })], (prev: any) => {
        return {
          ...prev,
          data: data.data['inbox-document'],
        };
      });

      queryClient.invalidateQueries([...activityLogsKeys.list(fileId)]);
    },
    ...config,
    mutationFn: ({ workstreamIds }) => tagFileWorkstream({ fileId, workstreamIds }),
  });
};
